export const BILLER_COLOR_MAP = {
  CYFROWY_POLSAT: '#f7941e',
  ENERGA24: '#80003B',
  INNOGY: '#f59b00',
  MULTIMEDIA: '#eb1946',
  NCPLUS: '#000000',
  NETFLIX: '#e50914',
  NETIA: '#009cff',
  NJU: '#00b1cd',
  ORANGE: '#f16e00',
  PGE: '#F7772C',
  PGNIG_GOH: '#0a1d64',
  PGNIG_MOH: '#0a1d64',
  PLAY: '#583787',
  PLUS: '#35a735',
  SPOTIFY: '#1DB954',
  'T-MOBILE': '#e30074',
  TAURON: '#e2007a',
  TOMSA: '#149AC4',
  UPC: '#239a98',
  VECTRA: '#385dae',
  WODOCIĄGI_BIAŁOSTOCKIE: '#0279b8',
};
